import { ToolbarOptions } from "@zebrabi/global-toolbar-old/interface/ToolbarOption";
import { store as annotationLayerStore } from "@zebrabi/annotation-layer";
import BaseSwitcherWithHeaderOld from "./BaseSwitcherWithHeaderOld";

/**
 * Toolbar button that enters and leaves the annotation layer's annotation mode, the way the Power BI visual's toolbar
 * does. While the mode is on, the annotation layer draws its own hover toolbar on the CAGR arrow (settings, delete).
 */
export default class AnnotationModeSwitcher extends BaseSwitcherWithHeaderOld {
    static readonly CLASS_NAME = "AnnotationModeSwitcher";

    public toolbarOptions: ToolbarOptions = {
        actions: [],
        elementName: "Edit CAGR arrow",
        icon: "annotation-mode-icon-base64",
        type: "button",
    };

    public getClassName(): string {
        return AnnotationModeSwitcher.CLASS_NAME;
    }

    public buttonAction(): void {
        return;
    }

    public update(): void {
        return;
    }

    public createMenuItems(): void {}

    public createOptions(useAltIcon?: boolean, overrideUseAltIcon?: boolean): HTMLElement {
        const container = super.createOptions(useAltIcon, overrideUseAltIcon);
        container.querySelector(".group-icon .icon")?.classList.toggle("active", annotationLayerStore.isInAnnotationMode);

        return container;
    }
}
